import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import styled from "styled-components/macro";

import { faDollarSign } from "@fortawesome/pro-solid-svg-icons";

import FnrInput2 from "UI/FnrInput2";

import { useRecurringGifts } from "../../../RecurringGiftsContext";
import { useAmount } from "../stateHooks";

export default function AmountInput() {
  const { state } = useRecurringGifts();
  const { isSubmitting } = state.editModal;
  const [amountInDollars, setAmountInDollars] = useAmount();

  const handleChange = (newValue) => {
    setAmountInDollars(newValue);
  };

  // 60 icon + 14 margin-right + 356 section = 430 total

  return (
    <Wrapper>
      <Icon>
        <FontAwesomeIcon icon={faDollarSign} />
      </Icon>
      <InputWrapper>
        <MaskedInput
          data-cy="recurringAmount"
          value={amountInDollars || ""}
          setValue={handleChange}
          disabled={isSubmitting}
          type="currency"
          alignLeft
        />
      </InputWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Icon = styled.div`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: 32px;
  margin-right: 14px;
  background: rgb(0, 180, 78);
  position: relative;
  overflow: hidden;
`;

const InputWrapper = styled.div`
  border: 2px solid rgba(190, 195, 199, 0);
  border-radius: 9px;

  &:hover {
    transition: border 0.2s;
    border: 2px solid rgba(190, 195, 199, 1);
  }
  &:focus-within {
    transition: border 0.2s;
    border: 2px solid rgba(190, 195, 199, 1);
  }
`;

const MaskedInput = styled(FnrInput2)`
  & input {
    box-sizing: border-box;
    width: 100%;
    font-size: 50px;
    font-weight: 600;
    color: #474747;
    border-radius: 8px;
    background: transparent;
    border: none;
    font-variant-numeric: tabular-nums;
    font-family: Montserrat;
    appearance: none;
    padding: 0;
    margin: 0;

    &::-moz-placeholder {
      color: #9a9a9a;
      opacity: 1;
    }
    &::placeholder {
      color: #9a9a9a;
    }
    &:focus {
      outline: 0;
    }
  }
`;
